import { Record } from 'immutable'

import type { DeepNullable } from '@albacross/types'

import type { ExportData } from '../store/App'

export const ExportRecord = Record<DeepNullable<ExportData>>({
  fileName: null,
  url: '',
  method: '',
  data: null,
  target: null,
})
